import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { api } from '@consts/url.const';
import { Observable } from 'rxjs';
import { CertificatesModel } from '@models/certificates.model';

@Injectable({ providedIn: 'root' })
export class CertificateService {
  constructor(private http: HttpClient) {}

  public getByFilters(
    filters: CertificatesModel.RequestFilter,
    page: number = 1,
    limit: number = CertificatesModel.PAGE_LIMIT,
  ): Observable<CertificatesModel.API.Response> {
    let httpParams = new HttpParams();

    if (filters.status) {
      httpParams = httpParams.set('status', filters.status);
    }

    if (filters.query) {
      httpParams = httpParams.set('query', filters.query);
    }

    httpParams = httpParams.set('page', page);
    httpParams = httpParams.set('limit', limit);

    return this.http.get<CertificatesModel.API.Response>(api.certificates.get, { params: httpParams });
  }
}
